<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Sticker" class="d-icon d-icon--sticker" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.44 1.44A1.5 1.5 0 0 1 2.5 1h5.25a.5.5 0 0 1 .354.147l2.75 2.75A.5.5 0 0 1 11 4.25V9.5A1.5 1.5 0 0 1 9.5 11h-7C1.674 11 1 10.328 1 9.5v-7c0-.397.158-.779.44-1.06ZM9.543 4 8 2.458V4h1.543ZM7 2v2.5a.5.5 0 0 0 .5.5H10v4.5a.5.5 0 0 1-.5.5h-7a.503.503 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5H7ZM3 6.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm4.5 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm-.213 1.34a.5.5 0 0 1 .123.697L7 8l.41.287-.001.002-.001.001-.003.004-.008.01a1.14 1.14 0 0 1-.093.112 1.86 1.86 0 0 1-.262.236C6.812 8.822 6.46 9 6 9c-.44 0-.79-.182-1.015-.343a2.13 2.13 0 0 1-.363-.33l-.007-.008-.003-.004H4.61l-.001-.002L5 8l-.39.313a.5.5 0 0 1 .778-.628l.005.005a1.13 1.13 0 0 0 .173.153A.76.76 0 0 0 6 8c.19 0 .339-.071.446-.151a.858.858 0 0 0 .148-.14.5.5 0 0 1 .693-.118Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSticker',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
